import React from "react";
import Styles from "./Advertise.module.css";

const Advertise = () => {
  return (
    <div className={Styles.main}>
      <img
        src="https://tpc.googlesyndication.com/simgad/931568015193886157?"
        alt=""
      />
    </div>
  );
};

export default Advertise;
